// extracted by mini-css-extract-plugin
module.exports = {"button":"read_more_button__3oEUD","up":"read_more_up__2hqNa","down":"read_more_down__2R8uj"};